<template>
  <div :class="`home ${isM ? 'm' : ''}`">
    <div class="content">
      <i class="logo"></i>
      <div class="container_b">
        <i class="text_i"></i>
        <div
          :class="`roll_btn ${rollAni ? 'rollAni' : ''}`"
          @click="roll"
        ></div>
        <div class="roll_times">剩余{{ lotteryTimes }}次</div>
        <i class="rule_btn" @click="popShow = 'rule'"></i>
        <i class="card_btn" @click="popShow = 'detail'"></i>
        <i class="task_btn" @click="popShow = 'task'"></i>
        <i class="reward_btn" @click="popShow = 'reward'"></i>
      </div>
      <div
        class="login_btn"
        v-if="!loginStatus"
        @click="loginShow = true"
      ></div>
      <div class="user_box" v-else>
        <span>您好，{{ mobile }}&nbsp;&nbsp;&nbsp;{{ nickname }}</span>
        <div class="btn_box">
          <div
            class="change_btn"
            v-if="!renamed"
            @click="popShow = 'change'"
          ></div>
          <div class="quit_btn" @click="loginOut"></div>
        </div>
      </div>
    </div>
    <div class="pop" v-if="popShow">
      <div class="rule_pop" v-if="popShow == 'rule'">
        <i class="close" @click="popShow = ''"></i>
      </div>
      <div class="vx_code_pop" v-if="popShow == 'vx'">
        <i class="close" @click="popShow = 'task'"></i>
      </div>
      <div class="public_pop" v-if="popShow == 'tip'">
        <i class="btn" @click="popShow = ''"></i>
        <span>{{ tipText }}</span>
      </div>
      <div class="task_pop" v-if="popShow == 'task'">
        <i class="close" @click="popShow = ''"></i>
        <div class="task_list">
          <div class="task_item" v-for="(item, index) in taskList" :key="index">
            <span class="text">{{ item.task }}</span>
            <div
              class="task_btn"
              v-if="item.num != item.finishNum"
              @click="goTask(index)"
            >
              {{ index == 3 ? '复制链接' : '前往关注' }}
            </div>
            <div class="task_btn task_ed" v-else>
              {{ index == 3 ? '已邀请' : '已关注' }}
            </div>
            <span class="times">{{ item.finishNum + '/' + item.num }}</span>
          </div>
        </div>
        <div class="user_list">
          <div class="user_item" v-for="(item, index) in userList" :key="index">
            <div class="user_box" v-if="item.name">
              <i class="user_avatar"></i>
              <span>{{ item.name }}</span>
            </div>
          </div>
          <div class="tip_text" v-if="userList.length <= 3">
            队伍人数达到<span>3</span>人，队伍<br />内每人解锁<span>1</span>个背包格子
          </div>
        </div>
      </div>
      <div class="detail_pop" v-if="popShow == 'detail'">
        <i class="close" @click="popShow = ''"></i>
        <div class="card_box">
          <div class="tab_i">出率70%</div>
          <div class="card_list card_list1">
            <div
              class="card_item"
              v-for="(item, index) in cardList1"
              :key="index"
              @click="getDetail(item.code)"
            >
              <i :class="`icon ${item.type}`"></i>
              <i class="border"></i>
              <img
                :src="`//media.zlongame.com/media/pictures/cn/community/img/rox/gameInfo/Card/${item.img}.png`"
                alt=""
              />
              <span class="name">{{ item.name }}</span>
            </div>
          </div>
          <div class="tab_i">出率30%</div>
          <div class="card_list card_list2">
            <div
              class="card_item"
              v-for="(item, index) in cardList2"
              :key="index"
              @click="getDetail(item.code)"
            >
              <i :class="`icon ${item.type}`"></i>
              <i class="border"></i>
              <img
                :src="`//media.zlongame.com/media/pictures/cn/community/img/rox/gameInfo/Card/${item.img}.png`"
                alt=""
              />
              <span class="name">{{ item.name }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="change_pop" v-if="popShow == 'change'">
        <i class="close" @click="popShow = ''"></i>
        <div class="input_box">
          <input
            type="text"
            placeholder="请输入昵称"
            v-model="renickname"
            maxlength="6"
          />
          <!-- <div class="btn">检测</div> -->
          <span class="tip" v-if="testTip">{{ testTip }}</span>
        </div>
        <div class="btn confirm_btn" @click="reNickName">确定</div>
      </div>
      <div class="reward_pop" v-if="popShow == 'reward'">
        <i class="close" @click="popShow = ''"></i>
        <div class="store_box">
          <div
            class="card_item"
            v-for="(item, index) in storeList"
            :key="index"
            @click="getStore(item.code, 1, index)"
          >
            <i :class="`icon ${item.type}`"></i>
            <i class="border"></i>
            <img
              :src="`//media.zlongame.com/media/pictures/cn/community/img/rox/gameInfo/Card/${item.img}.png`"
              alt=""
            />
          </div>
        </div>
        <div class="backpage_box">
          <div class="card_item" v-for="(item, index) in myList" :key="index">
            <i :class="`icon ${item.type}`"></i>
            <i
              v-if="item.img"
              class="border"
              @click="getStore(item.code, 2, index)"
            ></i>
            <img
              v-if="item.img"
              :src="`//media.zlongame.com/media/pictures/cn/community/img/rox/gameInfo/Card/${item.img}.png`"
              alt=""
            />
            <img v-else src="../assets/img/pc/pop/no_card.png" alt="" />
          </div>
          <div class="no_border" v-if="myList.length == 1">
            <span>队伍人数达到3人即可<br />解锁第二个卡片格子</span>
          </div>
        </div>
        <div class="get_btn" @click="getReward" v-if="!getRwd"></div>
        <div class="get_btn get_ed" v-else></div>
      </div>
      <div class="lottery_pop" v-if="popShow == 'lottery'">
        <div class="lottery_list">
          <div
            class="card_box"
            v-for="(item, index) in lotteryList"
            :key="index"
            @click="selectIndex = index"
          >
            <i class="select_on" v-show="selectIndex == index"></i>
            <div class="title_box">{{ item.name }}</div>
            <div class="info_box">
              <div class="info_text">
                <span>镶嵌部位：{{ item.type | typeDesc }}</span>
                <span>使用等级：1</span>
              </div>
              <div class="card_img">
                <i :class="`icon ${item.type}`"></i>
                <i class="border"></i>
                <img
                  :src="`//media.zlongame.com/media/pictures/cn/community/img/rox/gameInfo/Card/${item.img}.png`"
                  alt=""
                />
              </div>
            </div>
            <div class="data_box">
              <span>卡片效果</span>
              <span v-html="descText(item.desc)"></span>
            </div>
          </div>
        </div>
        <span class="tip">在结果中任选一张卡片存入仓库</span>
        <div class="btn" @click="selectReward"></div>
      </div>
      <div class="select_pop" v-if="popShow == 'select'">
        <i class="close" @click="popShow = ''"></i>
        <div class="user_list">
          <div
            class="user_item"
            v-for="(item, index) in roleList"
            :key="index"
            @click="currentRoleIndex = index"
          >
            <i class="select_on" v-show="currentRoleIndex == index"></i>
            <div class="tab_box">
              <span>角色名称</span>
              <span>等级</span>
              <span>大区</span>
              <span>服务器</span>
            </div>
            <div class="tab_text">
              <span>{{ item.role_name }}</span>
              <span>{{ item.role_level }}</span>
              <span>{{ item.zone_name }}</span>
              <span>{{ item.server_name }}</span>
            </div>
          </div>
        </div>
        <div class="reward_btn" @click="requestReward"></div>
      </div>
    </div>
    <Card ref="card" :card="cardList[currentCardIndex]" v-show="cardShow" />
    <Login v-if="loginShow" />
    <div class="wx_pop" v-if="wxShow">
      <i class="wx_tip"></i>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant';
import {
  getInfo,
  rename,
  lottery,
  choice,
  task,
  getRole,
  reward
} from '../api/index';
import Card from '../components/Card.vue';
import Login from '../components/Login.vue';
import cardData from '../utils/cardData.json';
export default {
  components: {
    Card,
    Login
  },
  data() {
    return {
      mobile: '',
      wxShow: false,
      isM: false,
      rollAni: false,
      testTip: '', //修改昵称提示
      tipText: '', //弹窗提示文字
      loginShow: false, //登录弹窗
      loginStatus: 0, //0未登录 1已登录
      selectIndex: null,
      cardShow: false, //卡片详情显隐
      currentCardIndex: 0,
      popShow: '',
      lotteryTimes: 0, //抽奖次数
      inviteCode: '', //邀请码
      nickname: '', //昵称
      renickname: '', //改昵称
      renamed: 0, //是否改名过。0-没改过 1-改过
      getRwd: false, //是否领取过奖励
      openReward: false, //是否开放领奖
      currentRoleIndex: 0, //领奖选择角色
      taskList: [
        {
          task: '关注官方抖音号',
          num: 1,
          finishNum: 0
        },
        {
          task: '关注官方TapTap',
          num: 1,
          finishNum: 0
        },
        {
          task: '关注官方公众号',
          num: 1,
          finishNum: 0
        },
        {
          task: '邀请好友',
          num: 2,
          finishNum: 0
        }
      ],
      roleList: [], //玩家角色信息
      userList: [{}, {}, {}],
      cardList: cardData,
      cardList1: [], //70%
      cardList2: [], //30%
      storeList: [], //仓库
      myList: [{}], //背包 默认只有一个格子
      lotteryList: [], //抽奖数组
      inviteLink: '' //邀请地址
    };
  },
  filters: {
    typeDesc(val) {
      let text;
      switch (val) {
        case 'armor':
          text = '衣服';
          break;
        case 'shawl':
          text = '披风';
          break;
        case 'accessory':
          text = '饰品';
          break;
        case 'headwear':
          text = '头饰';
          break;
        case 'weapon':
          text = '武器';
          break;
        case 'shoes':
          text = '鞋子';
          break;
      }
      return text;
    }
  },
  computed: {},
  watch: {
    nickname: function () {
      this.mobile =
        JSON.parse(localStorage.getItem('rox_lottery_card')).phone.substring(
          0,
          3
        ) +
        '****' +
        JSON.parse(localStorage.getItem('rox_lottery_card')).phone.substring(7);
    },
    popShow: function () {
      if (this.popShow == 'task' || this.popShow == 'reward') {
        if (!this.loginStatus) {
          this.popShow = '';
          this.loginShow = true;
        }
      } else if (this.popShow == '') {
        if (this.tipText.includes('背包') || this.tipText.includes('仓库')) {
          this.popShow = 'reward';
          this.tipText = '';
        }
      }
    }
  },
  methods: {
    requestReward() {
      reward({
        serverId: this.roleList[this.currentRoleIndex].server_id,
        roleId: this.roleList[this.currentRoleIndex].role_id
      }).then((res) => {
        if (res.data.data.code == 0) {
          this.getTip('领取成功');
        } else {
          switch (res.data.data.code) {
            case 4005:
              this.getTip('登录状态过期,请重新登录');
              break;
            case 5025:
              this.getTip('已经领取过奖励');
              break;
            case 5011:
              this.getTip('活动已结束');
              break;
            case 5002:
              this.getTip('角色不存在');
              break;
            case 5004:
              this.getTip('角色与账号不匹配');
              break;
            default:
              this.getTip(`领奖异常--${res.data.data.code}`);
              break;
          }
        }
      });
    },
    getReward() {
      if (this.openReward) {
        if (this.myList[0]?.name) {
          //判断不是空背包
          if (this.roleList.length == 0) {
            this.getTip('请先创建游戏角色');
          }
          // if (this.roleList.length == 1) {
          //   this.requestReward();
          // } else if (this.roleList.length > 1)
          else {
            this.popShow = 'select';
          }
        } else {
          this.getTip('请先将卡片取至背包后领取');
        }
      } else {
        this.getTip('亲爱的冒险者，目前不在奖励领取时间，详情请查看活动规则。');
      }
    },
    goTask(index) {
      if (index == 3) {
        var contentToCopy = this.inviteLink;
        var tempInput = $('<input>');
        $('body').append(tempInput);
        tempInput.val(contentToCopy).select();
        document.execCommand('copy');
        tempInput.remove();
        this.getTip('邀请链接已复制到粘贴板');
      } else {
        switch (index) {
          case 0:
            window.open(
              'https://www.douyin.com/user/MS4wLjABAAAAK7vakzhueca-U_jSP2x4ickZU7swP4ElGuDtchXnYhaop4jy6x_m6F5MqGASn_QP'
            );
            break;
          case 1:
            window.open('https://www.taptap.cn/app/707652');
            break;
          case 2:
            this.popShow = 'vx';
            break;
        }
        task({ id: index + 1 }).then((res) => {
          if (res.data.data.code == 0) {
            this.taskList[index].finishNum = 1;
            this.lotteryTimes++;
          } else {
            this.getTip(`任务异常--code:${res.data.data.code}`);
          }
        });
      }
    },
    selectReward() {
      if (this.selectIndex != null) {
        choice({ code: this.lotteryList[this.selectIndex].code }).then(
          (res) => {
            if (res.data.data.code == 0) {
              this.getTip(`已存入仓库`);
              this.init();
            } else {
              this.getTip(`存入失败--code:${res.data.data.code}`);
            }
            this.selectIndex = null;
          }
        );
      }
    },
    roll() {
      if (this.loginStatus) {
        if (!this.getRwd) {
          if (!this.rollAni) {
            if (this.lotteryTimes > 0) {
              console.log('222');
              this.rollAni = true;
              setTimeout(() => {
                lottery().then((res) => {
                  console.log(res);
                  if (res.data.data.code == 0) {
                    this.lotteryList = res.data.data.info.box.map((item) => {
                      return this.cardList.find((childItem) => {
                        return childItem.code == item;
                      });
                    });
                    this.rollAni = false;
                    this.popShow = 'lottery';
                  } else {
                    this.getTip(`抽奖失败--code:${res.data.data.code}`);
                  }
                });
              }, 800);
            } else {
              this.getTip(`抽奖次数不足`);
            }
          }
        } else {
          this.getTip(
            '您已成功领取喵手商团的礼赠，无法再次参与本抽卡活动，感谢您的参与~'
          );
        }
      } else {
        this.loginShow = true;
      }
    },
    reNickName() {
      rename({
        nickname: this.renickname
      }).then((res) => {
        console.log(res);
        if (res.data.data.code == 0) {
          this.nickname = this.renickname;
          Toast('修改成功');
          this.popShow = '';
        } else if (res.data.data.code == 19) {
          Toast(`存在违规内容`);
        } else {
          Toast(`修改失败--code:${res.data.data.code}`);
        }
      });
    },
    loginOut() {
      localStorage.removeItem('rox_lottery_card');
      location.reload();
    },
    getRoleList() {
      let uid = JSON.parse(localStorage.getItem('rox_lottery_card')).userid;
      let t = new Date().getTime();
      let params1 = {
        t: t,
        appKey: 1693534261653,
        userId: 80171000000002 + uid,
        sign: this.$md5(
          'EkBbHhyumyzGUffGuxOhMrn2yhtBglzQ' + 80171000000002 + uid + t
        )
      };
      getRole(params1).then((res) => {
        console.log(res, '000'); //res.da
        if (res.data.code == 0) {
          this.roleList = res.data.roleInfoList;
        } else {
          this.getTip(`查询关联账户信息失败--${res.data.code}`);
        }
      });
    },
    init() {
      if (localStorage.getItem('rox_lottery_card')) {
        getInfo().then((res) => {
          console.log(res);
          let info = res.data.data;
          if (info.success) {
            this.inviteCode = info.info.code;
            this.nickname = info.info.nickname;
            this.renamed = info.info.renamed;
            this.lotteryTimes = info.info.remain;
            this.getRwd = info.info.getRwd;
            if (info.info.now >= info.info.getRwdStamp) {
              this.openReward = true;
            }
            this.taskList[0].finishNum = info.info.task1;
            this.taskList[1].finishNum = info.info.task2;
            this.taskList[2].finishNum = info.info.task3;
            this.taskList[3].finishNum = info.info.members.length - 1;
            this.inviteLink =
              '速来！我正在「仙境传说RO：新启航」喵手商团抽卡，能不能抽到心仪卡片就靠你的助力了！点点点' +
              window.location.href.split('?')[0] +
              `?code=${info.info.code}`;
            info.info.members.forEach((item, index) => {
              this.userList[index].name = item;
            });
            this.storeList = info.info.got.map((item) => {
              let obj = this.cardList.find((itemChild) => {
                return itemChild.code == item.code;
              });
              // obj.id = item.id; //存储的是内存地址，需要深拷贝
              return Object.assign({}, { id: item.id }, obj);
            });
            if (info.info.bag.length > 0) {
              //去除背包里的卡片，剩余的才是仓库里的
              this.storeList = this.storeList.filter((item) => {
                if (info.info.bag.length == 1) {
                  return item.id != info.info.bag[0];
                } else {
                  return (
                    item.id != info.info.bag[0] && item.id != info.info.bag[1]
                  );
                }
              });
            }
            if (info.info.bag.length > 0) {
              this.myList = info.info.bag.map((item) => {
                let childIndex = info.info.got.findIndex((itemChild) => {
                  return itemChild.id == item;
                });
                let obj = this.cardList.find((item) => {
                  return item.code == info.info.got[childIndex].code;
                });
                console.log(item);
                // obj.id = item;
                // return obj;
                return Object.assign({}, { id: item }, obj);
              });
            }
            //前面背包里若存放一张卡片时，myList只有一个卡片位
            if (info.info.members.length == 3 && this.myList.length == 1) {
              //开启第二个格子
              this.myList.push({});
            }
            this.loginStatus = 1;
            this.loginShow = false;
          } else {
            this.getTip(`活动查询失败--code:${info.code}`);
          }
        });
        this.getRoleList();
      } else {
        let randomNum = 'webpay_' + Math.random().toFixed(40).substr(2, 40);
        localStorage.setItem('deviceId', randomNum);
      }
    },
    getTip(val) {
      this.tipText = val;
      this.popShow = 'tip';
    },
    getStore(code, type, cardTypeIndex) {
      //type 1取 2存
      let index = this.cardList.findIndex((item) => {
        return item.code == code;
      });
      this.currentCardIndex = index;
      this.$refs.card.btnType = type == 1 ? '取至背包' : '存入仓库';
      this.$refs.card.cardTypeIndex = cardTypeIndex;
      this.cardShow = true;
    },
    getDetail(code) {
      let index = this.cardList.findIndex((item) => {
        return item.code == code;
      });
      this.currentCardIndex = index;
      this.cardShow = true;
    },
    descText(val) {
      return val.replace('，', '<br>');
    },
    _isMobile() {
      var userAgentInfo = navigator.userAgent;
      var Agents = new Array(
        'Android',
        'iPhone',
        'SymbianOS',
        'Windows Phone',
        'iPad',
        'iPod',
        'Windows CE',
        'BlackBerry'
      );
      var flag = false;
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = true;
          break;
        }
      }
      let isiPad =
        navigator.userAgent.match(/(iPad)/) ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
      if (!flag && isiPad) {
        flag = true;
      }
      return flag;
    }
  },
  created() {
    this.init();
    this.cardList1 = cardData.filter((item) => {
      return item.probability == '2.33%' || item.probability == '2.43%';
    });
    this.cardList2 = cardData.filter((item) => {
      return item.probability == '1.00%';
    });
  },
  mounted() {
    this.isM = this._isMobile();
    if (this.isM) {
      var isWeixin = /MicroMessenger/i.test(navigator.userAgent);
      if (isWeixin) {
        // 如果是微信内置浏览器，执行相关代码
        this.wxShow = true;
        return;
      }
      if (window.orientation === 180 || window.orientation === 0) {
        $('html').css({
          // display: 'flex',
          // 'justify-content': 'center',
          // ' align-items': 'center'
        });
        $('html,body').css({ overflow: 'hidden' /* 防止内容溢出 */ });
        $('body').css({
          transform: 'rotate(90deg)',
          'transform-origin': 'center center',
          width: '100vh' /* 设为视窗高度 */,
          height: '100vw' /* 设为视窗宽度 */,
          'overflow-x': 'hidden',
          position: 'absolute',
          top: '50%',
          left: '50%',
          margin: '-50vw 0 0 -50vh' /* 通过负边距将页面居中 */
        });
        $('#app').css({
          width: '100vh' /* 设为视窗高度 */,
          height: '100vw' /* 设为视窗宽度 */
        });
        $('.login_btn').css({
          right: '1.8rem'
        });
      } else {
      }
      // 判断屏幕是否旋转
      window.addEventListener('orientationchange', function () {
        location.reload();
      });
    }
  }
};
</script>
<style lang='less' scoped>
.home {
  width: 100%;
  height: 100%;
  background: url('../assets/img/pc/bg.jpg');
  background-size: cover;
  background-position: center center;
  display: flex;
  justify-content: center;
  align-items: center;
  .content {
    width: 19.2rem;
    height: 10.8rem;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    .container_b {
      width: 15.04rem;
      height: 8.56rem;
      background: url('../assets/img/pc/content.png');
      background-size: 100% 100%;
      position: relative;
      .roll_btn {
        width: 1.76rem;
        height: 1.75rem;
        background: url('../assets/img/pc/roll_btn.png');
        background-size: 100% 100%;
        position: absolute;
        bottom: 0.76rem;
        left: 2.94rem;
        cursor: pointer;
      }
      .rollAni {
        animation: move 0.8s 1 linear;
      }

      @keyframes move {
        0% {
          transform: rotate(0deg);
        }
        50% {
          transform: rotate(90deg);
        }
        100% {
          transform: rotate(0deg);
        }
      }
      .text_i {
        width: 1.23rem;
        height: 0.74rem;
        background: url('../assets/img/pc/text_i.png');
        background-size: 100% 100%;
        position: absolute;
        bottom: 2.34rem;
        left: 3.2rem;
        z-index: 2;
        pointer-events: none;
      }
      .roll_times {
        width: 1.26rem;
        height: 0.36rem;
        background: #7596c0;
        border-radius: 0.18rem;
        border: 0.02rem solid #5f80a9;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 0.22rem;
        color: #ffffff;
        position: absolute;
        bottom: 0.3rem;
        left: 3.22rem;
      }
      .rule_btn {
        width: 0.75rem;
        height: 0.75rem;
        position: absolute;
        bottom: 0.9rem;
        right: 3.28rem;
        cursor: pointer;
      }
      .card_btn {
        width: 0.75rem;
        height: 0.75rem;
        position: absolute;
        bottom: 0.9rem;
        right: 2.2rem;
        cursor: pointer;
      }
      .task_btn {
        width: 1.19rem;
        height: 1.09rem;
        position: absolute;
        right: 0.6rem;
        top: 2.86rem;
        cursor: pointer;
      }
      .reward_btn {
        width: 0.97rem;
        height: 0.88rem;
        position: absolute;
        right: 0.8rem;
        top: 4.22rem;
        cursor: pointer;
      }
    }
    .logo {
      width: 2.78rem;
      height: 1.31rem;
      background: url('../assets/img/pc/logo.png');
      background-size: 100% 100%;
      position: absolute;
      top: 0;
      left: 0;
    }
    .login_btn {
      width: 0.91rem;
      height: 0.38rem;
      background: url('../assets/img/pc/login.png');
      background-size: 100% 100%;
      position: fixed;
      top: 0.54rem;
      right: 0.76rem;
      cursor: pointer;
    }
    .user_box {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      position: fixed;
      top: 0.54rem;
      right: 0.76rem;
      span {
        font-size: 0.2rem;
        color: #526c8c;
      }
      .btn_box {
        display: flex;
        margin-top: 0.2rem;
        .change_btn {
          width: 1.13rem;
          height: 0.38rem;
          background: url('../assets/img/pc/change.png');
          background-size: 100% 100%;
          margin-right: 0.1rem;
          cursor: pointer;
        }
        .quit_btn {
          width: 0.91rem;
          height: 0.38rem;
          background: url('../assets/img/pc/quit.png');
          background-size: 100% 100%;
          cursor: pointer;
        }
      }
    }
  }
  .pop {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9;
    display: flex;
    justify-content: center;
    align-items: center;
    .close {
      width: 0.77rem;
      height: 0.72rem;
      position: absolute;
      right: 0;
      top: 0.1rem;
      cursor: pointer;
    }
    .rule_pop {
      width: 12.68rem;
      height: 7.26rem;
      background: url('../assets/img/pc/pop/rule_pop.png');
      background-size: 100% 100%;
    }
    .public_pop {
      width: 5.83rem;
      height: 3.68rem;
      background: url('../assets/img/pc/pop/public_pop.png');
      background-size: 100% 100%;
      display: flex;
      justify-content: center;
      padding: 0 0.5rem;
      box-sizing: border-box;
      span {
        font-family: 'SourceHanSerifCNBold';
        font-size: 0.24rem;
        color: #4a617e;
        margin-top: 1.2rem;
        text-align: center;
      }
      .btn {
        width: 2.05rem;
        height: 0.62rem;
        background: url('../assets/img/pc/pop/btn.png');
        background-size: 100% 100%;
        position: absolute;
        bottom: 0.8rem;
        cursor: pointer;
      }
    }
    .task_pop {
      width: 12.68rem;
      height: 7.26rem;
      background: url('../assets/img/pc/pop/task_pop.png');
      background-size: 100% 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      .task_list {
        margin-top: 1.5rem;
        transform: translateX(-0.36rem);
        width: 11.1rem;
        height: 1.9rem;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        .task_item {
          width: 5.39rem;
          height: 0.78rem;
          background: url('../assets/img/pc/pop/task_bg.png');
          background-size: 100% 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 0.22rem;
          box-sizing: border-box;
          position: relative;
          span {
            font-family: 'SourceHanSerifCNBold';
            font-size: 0.22rem;
            color: #4a617e;
          }
          .task_btn {
            width: 1.3rem;
            height: 0.42rem;
            background: url('../assets/img/pc/pop/task_btn.png');
            background-size: 100% 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            font-family: 'SourceHanSerifCNBold';
            font-weight: 800;
            font-size: 0.2rem;
            color: #64340b;
            cursor: pointer;
          }
          .task_ed {
            -webkit-filter: grayscale(100%);
            -moz-filter: grayscale(100%);
            -o-filter: grayscale(100%);
            filter: grayscale(100%);
          }
          .times {
            position: absolute;
            right: 2.04rem;
          }
        }
      }
      .user_list {
        width: 11.06rem;
        height: 1.9rem;
        position: absolute;
        left: 0.5rem;
        bottom: 1.1rem;
        display: flex;
        // justify-content: space-around;
        .user_item {
          width: 1.11rem;
          height: 1.11rem;
          background: url('../assets/img/pc/pop/user_no.png');
          background-size: 100% 100%;
          margin: 0 0.5rem;
          margin-top: 0.3rem;

          .user_box {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            position: relative;
            .user_avatar {
              width: 100%;
              height: 100%;
              background: url('../assets/img/pc/pop/user_i.png');
              background-size: 100% 100%;
            }
            span {
              white-space: nowrap;
              font-family: 'SourceHanSerifCNBold';
              font-size: 0.2rem;
              color: #4a617e;
              position: absolute;
              bottom: -0.3rem;
            }
          }
        }
        .tip_text {
          width: 4.26rem;
          height: 1.47rem;
          font-size: 0.22rem;
          color: #4a617e;
          position: absolute;
          top: 0.2rem;
          right: 0;
          border-left: 0.01rem solid #aec1da;
          text-align: center;
          padding-top: 0.36rem;
          box-sizing: border-box;
          span {
            color: #9e7136;
          }
        }
      }
    }
    .detail_pop {
      width: 12.68rem;
      height: 7.26rem;
      background: url('../assets/img/pc/pop/detail_pop.png');
      background-size: 100% 100%;
      .card_box {
        width: 11.26rem;
        height: 5.33rem;
        margin-top: 1rem;
        margin-left: 0.36rem;
        display: flex;
        flex-direction: column;
        overflow-y: auto;
        .tab_i {
          transform: translate(0.4rem);
          width: 1.44rem;
          height: 0.45rem;
          background: #7596c0;
          border-radius: 0.1rem;
          border: 0.01rem solid #698bb6;
          font-size: 0.24rem;
          color: #ffffff;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .card_list {
          width: 100%;
          display: flex;
          flex-wrap: wrap;
          margin: 0 auto;
          .card_item {
            width: 1.04rem;
            height: 1.31rem;
            margin-top: 0.46rem;
            margin-right: 0.7rem;
            position: relative;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            .name {
              font-size: 0.18rem;
              color: #2e2925;
              position: absolute;
              bottom: -0.3rem;
              white-space: nowrap;
            }
            img {
              width: 100%;
              height: 100%;
            }
            .border {
              width: 1.04rem;
              height: 1.31rem;
              background: url('../assets/img/pc/pop/card_quality_1.png');
              background-size: 100% 100%;
              position: absolute;
            }
            .icon {
              width: 0.12rem;
              height: 0.12rem;
              position: absolute;
              top: 0.04rem;
              left: 0.04rem;
              z-index: 2;
            }
            .accessory {
              background: url('../assets/img/pc/pop/accessory.png');
              background-size: 100% 100%;
            }
            .armor {
              background: url('../assets/img/pc/pop/armor.png');
              background-size: 100% 100%;
            }
            .headwear {
              background: url('../assets/img/pc/pop/headwear.png');
              background-size: 100% 100%;
            }
            .shawl {
              background: url('../assets/img/pc/pop/shawl.png');
              background-size: 100% 100%;
            }
            .shoes {
              background: url('../assets/img/pc/pop/shoes.png');
              background-size: 100% 100%;
            }
            .weapon {
              background: url('../assets/img/pc/pop/weapon.png');
              background-size: 100% 100%;
            }
          }
          .card_item:nth-child(-n + 6) {
            margin-top: 0.2rem;
          }
          .card_item:nth-child(6n + 1) {
            margin-left: 0.4rem;
          }
        }
        .card_list1 {
          margin-bottom: 0.8rem;
        }
      }
      .card_box::-webkit-scrollbar  {
        width: 0.06rem; /* 设置滚动条宽度 */
      }
      .card_box::-webkit-scrollbar-track {
        background: #c5d0dc; /* 设置滚动条背景颜色 */
        border-radius: 0.09rem; /* 设置滚动条圆角 */
      }
      .card_box::-webkit-scrollbar-thumb  {
        background: #90b2de; /* 设置滚动条滑块颜色 */
        border-radius: 0.09rem; /* 设置滚动条滑块圆角 */
      }
    }
    .change_pop {
      width: 10.73rem;
      height: 5.64rem;
      background: url('../assets/img/pc/pop/change_pop.png');
      background-size: 100% 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      .input_box {
        margin-top: 1.62rem;
        display: flex;
        align-items: center;
        transform: translate(-0.4rem);
        position: relative;
        input {
          width: 4.59rem;
          height: 0.63rem;
          border: 0.01rem solid #4e709b;
          margin-right: 0.2rem;
          font-weight: bold;
          font-size: 0.24rem;
          color: #526c8c;
          text-align: center;
          outline: none;
        }
        .tip {
          font-weight: bold;
          font-size: 0.24rem;
          color: #526c8c;
          position: absolute;
          top: 0.72rem;
        }
      }
      .btn {
        transform: translate(-0.4rem);
        width: 2.05rem;
        height: 0.62rem;
        background: url('../assets/img/pc/pop/change_btn.png');
        background-size: 100% 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: 800;
        font-size: 0.3rem;
        color: #64340b;
        cursor: pointer;
      }
      .confirm_btn {
        transform: translate(-0.4rem);
        margin-top: 1.6rem;
      }
    }
    .reward_pop {
      width: 14.57rem;
      height: 7.26rem;
      background: url('../assets/img/pc/pop/reward_pop.png');
      background-size: 100% 100%;
      .store_box {
        width: 6rem;
        height: 3.76rem;
        position: absolute;
        left: 0.64rem;
        top: 1.72rem;
        display: flex;
        flex-wrap: wrap;
        overflow: auto;
        padding-left: 0.12rem;
        box-sizing: border-box;
        .card_item {
          width: 1.04rem;
          height: 1.31rem;
          margin-right: 0.12rem;
          margin-top: 0.16rem;
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          img {
            width: 100%;
            height: 100%;
          }
          .border {
            width: 1.04rem;
            height: 1.31rem;
            background: url('../assets/img/pc/pop/card_quality_1.png');
            background-size: 100% 100%;
            position: absolute;
          }
          .icon {
            width: 0.12rem;
            height: 0.12rem;
            position: absolute;
            top: 0.04rem;
            left: 0.04rem;
            z-index: 2;
          }
          .accessory {
            background: url('../assets/img/pc/pop/accessory.png');
            background-size: 100% 100%;
          }
          .armor {
            background: url('../assets/img/pc/pop/armor.png');
            background-size: 100% 100%;
          }
          .headwear {
            background: url('../assets/img/pc/pop/headwear.png');
            background-size: 100% 100%;
          }
          .shawl {
            background: url('../assets/img/pc/pop/shawl.png');
            background-size: 100% 100%;
          }
          .shoes {
            background: url('../assets/img/pc/pop/shoes.png');
            background-size: 100% 100%;
          }
          .weapon {
            background: url('../assets/img/pc/pop/weapon.png');
            background-size: 100% 100%;
          }
        }
      }
      .store_box::-webkit-scrollbar  {
        width: 0.06rem; /* 设置滚动条宽度 */
      }
      .store_box::-webkit-scrollbar-track {
        background: #c5d0dc; /* 设置滚动条背景颜色 */
        border-radius: 0.09rem; /* 设置滚动条圆角 */
      }
      .store_box::-webkit-scrollbar-thumb  {
        background: #90b2de; /* 设置滚动条滑块颜色 */
        border-radius: 0.09rem; /* 设置滚动条滑块圆角 */
      }
      .backpage_box {
        width: 6rem;
        height: 3.76rem;
        position: absolute;
        right: 1.34rem;
        top: 1.72rem;
        display: flex;
        flex-wrap: wrap;
        overflow: auto;
        padding-left: 0.2rem;
        box-sizing: border-box;
        .card_item {
          width: 1.04rem;
          height: 1.31rem;
          margin-right: 0.12rem;
          margin-top: 0.16rem;
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          img {
            width: 100%;
            height: 100%;
          }
          .border {
            width: 1.04rem;
            height: 1.31rem;
            background: url('../assets/img/pc/pop/card_quality_1.png');
            background-size: 100% 100%;
            position: absolute;
          }
          .icon {
            width: 0.12rem;
            height: 0.12rem;
            position: absolute;
            top: 0.04rem;
            left: 0.04rem;
            z-index: 2;
          }
          .accessory {
            background: url('../assets/img/pc/pop/accessory.png');
            background-size: 100% 100%;
          }
          .armor {
            background: url('../assets/img/pc/pop/armor.png');
            background-size: 100% 100%;
          }
          .headwear {
            background: url('../assets/img/pc/pop/headwear.png');
            background-size: 100% 100%;
          }
          .shawl {
            background: url('../assets/img/pc/pop/shawl.png');
            background-size: 100% 100%;
          }
          .shoes {
            background: url('../assets/img/pc/pop/shoes.png');
            background-size: 100% 100%;
          }
          .weapon {
            background: url('../assets/img/pc/pop/weapon.png');
            background-size: 100% 100%;
          }
        }
        .no_border {
          width: 1.04rem;
          height: 1.31rem;
          border: 0.02rem dotted #aec1da;
          box-sizing: border-box;
          position: relative;
          margin-top: 0.16rem;
          display: flex;
          justify-content: center;
          span {
            font-weight: 400;
            font-size: 0.14rem;
            color: #475e7c;
            position: absolute;
            top: 1.36rem;
            white-space: nowrap;
            text-align: center;
          }
        }
      }
      .get_btn {
        width: 2.05rem;
        height: 0.62rem;
        background: url('../assets/img/pc/pop/get_btn.png');
        background-size: 100% 100%;
        position: absolute;
        bottom: 0.71rem;
        right: 1.39rem;
        cursor: pointer;
      }
      .get_ed {
        -webkit-filter: grayscale(100%);
        -moz-filter: grayscale(100%);
        -o-filter: grayscale(100%);
        filter: grayscale(100%);
      }
    }
    .lottery_pop {
      width: 12.03rem;
      height: 7.26rem;
      background: url('../assets/img/pc/pop/lottery_pop.png');
      background-size: 100% 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      .lottery_list {
        width: 10.34rem;
        height: 4.32rem;
        display: flex;
        justify-content: space-between;
        margin-top: 0.6rem;
        .card_box {
          width: 3.16rem;
          height: 4.32rem;
          background: url('../assets/img/pc/pop/lottery_card.png');
          background-size: 100% 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          position: relative;
          cursor: pointer;
          .select_on {
            width: 3.26rem;
            height: 4.42rem;
            background: url('../assets/img/pc/pop/select_on.png');
            background-size: 100% 100%;
            position: absolute;
            top: -0.06rem;
          }
          .title_box {
            width: 100%;
            height: 0.62rem;
            font-weight: 800;
            font-size: 0.28rem;
            color: #242c36;
            font-family: 'SourceHanSerifCNBold';
            display: flex;
            justify-content: center;
            align-items: center;
          }
          .info_box {
            width: 2.82rem;
            height: 1.31rem;
            margin-top: 0.28rem;
            display: flex;
            justify-content: space-between;
            .info_text {
              display: flex;
              flex-direction: column;
              span {
                font-size: 0.2rem;
                color: #2e2925;
              }
            }
            .card_img {
              width: 1.04rem;
              height: 1.31rem;
              position: relative;
              img {
                width: 100%;
                height: 100%;
              }
              .border {
                width: 1.04rem;
                height: 1.31rem;
                background: url('../assets/img/pc/pop/card_quality_1.png');
                background-size: 100% 100%;
                position: absolute;
              }
              .icon {
                width: 0.12rem;
                height: 0.12rem;
                position: absolute;
                top: 0.04rem;
                left: 0.04rem;
                z-index: 2;
              }
              .accessory {
                background: url('../assets/img/pc/pop/accessory.png');
                background-size: 100% 100%;
              }
              .armor {
                background: url('../assets/img/pc/pop/armor.png');
                background-size: 100% 100%;
              }
              .headwear {
                background: url('../assets/img/pc/pop/headwear.png');
                background-size: 100% 100%;
              }
              .shawl {
                background: url('../assets/img/pc/pop/shawl.png');
                background-size: 100% 100%;
              }
              .shoes {
                background: url('../assets/img/pc/pop/shoes.png');
                background-size: 100% 100%;
              }
              .weapon {
                background: url('../assets/img/pc/pop/weapon.png');
                background-size: 100% 100%;
              }
            }
          }
          .data_box {
            width: 2.82rem;
            display: flex;
            flex-direction: column;
            margin-top: 0.5rem;
            span {
              font-weight: bold;
              font-size: 0.2rem;
              color: #2e2925;
            }
            span:last-child {
              font-weight: normal;
            }
          }
        }
      }
      .tip {
        font-weight: bold;
        font-size: 0.24rem;
        color: #526c8c;
        margin-top: 0.4rem;
      }
      .btn {
        width: 2.05rem;
        height: 0.62rem;
        background: url('../assets/img/pc/pop/btn.png');
        background-size: 100% 100%;
        margin-top: 0.3rem;
        cursor: pointer;
      }
    }
    .select_pop {
      width: 12.68rem;
      height: 7.26rem;
      background: url('../assets/img/pc/pop/select_pop.png');
      background-size: 100% 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      .user_list {
        transform: translateX(-0.4rem);
        height: 3.9rem;
        margin-top: 1.4rem;
        overflow-x: hidden;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 0 0.1rem;
        .user_item {
          width: 10.09rem;
          height: 1.13rem;
          background: url('../assets/img/pc/pop/user_bg.png');
          background-size: 100% 100%;
          margin-bottom: 0.24rem;
          flex-shrink: 0;
          display: flex;
          flex-direction: column;
          position: relative;
          cursor: pointer;
          .select_on {
            width: 10.19rem;
            height: 1.23rem;
            background: url('../assets/img/pc/pop/select_on1.png');
            background-size: 100% 100%;
            position: absolute;
            top: -0.04rem;
            left: -0.05rem;
            cursor: pointer;
          }
          .tab_box {
            width: 100%;
            height: 0.5rem;
            display: flex;
            span {
              font-family: 'SourceHanSerifCNBold';
              flex: 1;
              font-weight: bold;
              font-size: 0.22rem;
              color: #4a617e;
              display: flex;
              justify-content: center;
              align-items: center;
            }
          }
          .tab_text {
            width: 100%;
            height: 0.63rem;
            display: flex;
            span {
              font-family: 'SourceHanSerifCNBold';
              flex: 1;
              font-size: 0.22rem;
              color: #2e2925;
              display: flex;
              justify-content: center;
              align-items: center;
            }
          }
        }
        .user_item:last-child {
          margin-bottom: 0;
        }
      }
      .user_list::-webkit-scrollbar  {
        width: 0.06rem; /* 设置滚动条宽度 */
      }
      .user_list::-webkit-scrollbar-track {
        background: #c5d0dc; /* 设置滚动条背景颜色 */
        border-radius: 0.09rem; /* 设置滚动条圆角 */
      }
      .user_list::-webkit-scrollbar-thumb  {
        background: #90b2de; /* 设置滚动条滑块颜色 */
        border-radius: 0.09rem; /* 设置滚动条滑块圆角 */
      }
      .reward_btn {
        width: 2.05rem;
        height: 0.62rem;
        transform: translateX(-0.36rem);
        margin-top: 0.54rem;
        cursor: pointer;
      }
    }
    .vx_code_pop {
      width: 12.68rem;
      height: 7.26rem;
      background: url('../assets/img/pc/pop/wx_code.png');
      background-size: 100% 100%;
    }
  }
  .pop > div {
    position: relative;
  }
}
.m {
  .content {
    // transform: scale(1.02);
    .login_btn {
      transform: scale(1.6);
      right: 1.2rem;
    }
    .user_box {
      transform: scale(1.6);
      right: 1.2rem;
    }
    .logo {
      transform: scale(1.6);
      position: fixed !important;
      top: 0.2rem !important;
      left: 1.2rem !important;
    }
  }
  .pop > div {
    transform: scale(1.2);
  }
  .m_tip {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 1);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1rem;
    color: #fff;
    text-align: center;
  }
  .wx_pop {
    width: 100%;
    height: 100vh;
    background-color: rgba(0, 0, 0, 1);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
    display: flex;
    justify-content: center;
    .wx_tip {
      width: 7.5rem;
      height: 8.8rem;
      background: url('https://media.zlongame.com/media/pictures/cn/ro/index/m/img/wx_tip.png');
      background-size: 100% 100%;
      transform: translateY(5rem) scale(2);
      position: absolute;
      top: 0;
    }
  }
}
</style>
